import type { NodeDefinition } from '@shared/types/node-definition';

const definition: NodeDefinition = {
  type: 'langchain-chat-memory',
  name: 'LangChain Chat Memory',
  description: 'Manage conversation history and context for chat applications',
  icon: 'MessageSquare',
  color: 'purple',
  category: 'ai-nodes',
  tags: ['langchain', 'chat', 'memory', 'conversation', 'history'],
  comingSoon: true,
  version: '1.0.0',
  inputs: [],
  outputs: [],
};

export default definition;
